<app-header class="no-print"></app-header>
<div class="price-check">
  <div class="entry-bar">
    <input #entry type="text" class="entry" [(ngModel)]="entryText" (keydown)="entryKeyDown($event)"
           placeholder="Scan an item or search" autocomplete="off" autocorrect="off" autocapitalize="off" spellcheck="false"
           [readonly]="!location" [class.needs-location]="!location" (click)="entryClick()" />
    <div class="clear" *ngIf="entryText || items.length || searchResults.length || notFound" (click)="clear()">Clear</div>
  </div>

  <div class="body">
    <div *ngIf="!location" class="prompt">
      <a class="prompt-link" (click)="entryClick()">Select a location</a> to check prices.
    </div>

    <ng-container *ngIf="location">
      <div *ngIf="busy" class="prompt muted">Looking up . . .</div>

      <!-- search results -->
      <div *ngIf="searchText" class="search-results">
        <div *ngIf="searchNoMatches" class="prompt">No matching products for "{{searchText}}"</div>
        <div *ngFor="let result of searchResults" class="search-result" (click)="selectSearchResult(result)">
          <div class="result-main">
            <div class="result-name">{{result.name}}</div>
            <div class="result-detail" *ngIf="resultDetail(result)">{{resultDetail(result)}}</div>
            <div class="result-sku" *ngIf="result.sku">{{result.sku}}</div>
          </div>
          <div class="result-price">
            <ng-container *ngIf="result.priceIsVariable">Variable</ng-container>
            <ng-container *ngIf="!result.priceIsVariable">{{result.price | rf:'currency'}}</ng-container>
          </div>
        </div>
      </div>

      <div *ngIf="!searchText && !items.length && !notFound && !busy" class="prompt muted">
        Scan an item or search to see its price, deals and stock at {{location.name}}.
      </div>

      <div *ngIf="notFound" class="not-found">
        <div class="title">No item found</div>
        <div class="code">{{lastCode}}</div>
      </div>

      <div *ngIf="items.length > 1" class="multi">{{items.length}} items match this barcode</div>

      <!-- item cards -->
      <div *ngFor="let item of items" class="card">
        <div class="card-head">
          <img *ngIf="item.imgUrl" [src]="item.imgUrl" class="image" alt="" />
          <div class="head-text">
            <div class="name">{{item.name}}</div>
            <div class="price-line">
              <ng-container *ngIf="item.priceIsVariable">
                <span class="price">Variable Price</span>
              </ng-container>
              <ng-container *ngIf="!item.priceIsVariable">
                <span class="original-price" *ngIf="item.discountedPrice != null">{{item.price | rf:'currency'}}</span>
                <span class="price" [class.sale-price]="item.discountedPrice != null">
                  {{(item.discountedPrice != null ? item.discountedPrice : item.price) | rf:'currency'}}
                </span>
              </ng-container>
            </div>
            <div class="discount-names" *ngIf="item.discountNames && item.discountNames.length">
              <span class="discount-name" *ngFor="let name of item.discountNames">{{name}}</span>
            </div>
          </div>
        </div>

        <div class="deals" *ngIf="item.deals && item.deals.length">
          <div class="deal" *ngFor="let deal of item.deals">
            <div class="deal-text">Buy {{deal.qty}} for {{deal.totalPrice | rf:'currency'}}
              <span class="each">({{deal.eachPrice | rf:'currency'}} each)</span></div>
            <div class="deal-names"><span *ngFor="let name of deal.names">{{name}}</span></div>
          </div>
        </div>

        <div class="facts">
          <div class="fact" *ngIf="item.sku"><label>SKU</label><div>{{item.sku}}</div></div>
          <div class="fact" *ngIf="item.categoryName"><label>Category</label><div>{{item.categoryName}}</div></div>
          <div class="fact" *ngIf="item.unitDescription"><label>Unit</label><div>{{item.unitDescription}}</div></div>
          <div class="fact" *ngIf="item.attr"><label>Attributes</label><div>{{item.attr}}</div></div>
          <div class="fact"><label>In Stock</label>
            <div>
              <ng-container *ngIf="item.inStock != null">{{item.inStock}} <span class="uom" *ngIf="item.unitOfMeasure">{{item.unitOfMeasure}}</span></ng-container>
              <ng-container *ngIf="item.inStock == null">&mdash;</ng-container>
            </div>
          </div>
          <div class="fact" *ngIf="item.barcode && item.barcode.length"><label>Barcode</label>
            <div class="barcodes"><span *ngFor="let code of item.barcode">{{code}}</span></div>
          </div>
        </div>

        <div class="print-buttons" *ngIf="printTemplates.length">
          <button class="button" *ngFor="let template of printTemplates" [disabled]="printing" (click)="printItem(item, template)">
            Print {{template.name}}
          </button>
        </div>

        <div class="other-locations" *ngIf="item.otherLocations && item.otherLocations.length">
          <div class="other-title">Other Locations</div>
          <div class="other-row" *ngFor="let other of item.otherLocations">
            <span>{{other.locationName}}</span>
            <span class="other-balance">{{other.balance}}</span>
          </div>
        </div>
      </div>
    </ng-container>
  </div>

  <app-support *ngIf="supportActive"></app-support>
  <app-settings *ngIf="settingsActive"></app-settings>
</div>
